export default __webpack_public_path__ + "static/media/covid care.fd939d08.mov";